var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    transform: "translate(0 -0.474)",
    fill: "#659ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.441,11.717v-.555H3.561l-.006,2.221a1.107,1.107,0,0,0,1.11,1.11h7.772a1.107,1.107,0,0,0,1.11-1.11V11.162H9.662v.555Zm5.552-5H10.767V5.61L9.657,4.5H7.436L6.326,5.61v1.11H4.11A1.114,1.114,0,0,0,3,7.831V9.5a1.107,1.107,0,0,0,1.11,1.11H7.441V9.5H9.662v1.11h3.331A1.114,1.114,0,0,0,14.1,9.5V7.831A1.114,1.114,0,0,0,12.993,6.721Zm-3.331,0H7.441V5.61H9.662Z",
    transform: "translate(1.948 1.004)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardPlan);
export default __webpack_public_path__ + "static/media/standard_plan.827c2024d0e298365f0d0c2bdbc0e8d7.svg";
export { ForwardRef as ReactComponent };